import { useState, useCallback } from 'react';
import { useEventListener } from '../../hooks/useEventListener';

const useNetwork = (): { isOnline: boolean | undefined } => {
  const [isOnline, setIsOnline] = useState<boolean | undefined>(
    navigator.onLine
  );

  const updateNetwork = useCallback(() => {
    setIsOnline(navigator.onLine);
  }, [setIsOnline]);

  useEventListener('offline', updateNetwork, window);
  useEventListener('online', updateNetwork, window);

  return { isOnline };
};

export default useNetwork;
